import { render, staticRenderFns } from "./BookkeepingBrowse.vue?vue&type=template&id=c5a0890e&scoped=true"
import script from "./BookkeepingBrowse.vue?vue&type=script&lang=ts"
export * from "./BookkeepingBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a0890e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5a0890e')) {
      api.createRecord('c5a0890e', component.options)
    } else {
      api.reload('c5a0890e', component.options)
    }
    module.hot.accept("./BookkeepingBrowse.vue?vue&type=template&id=c5a0890e&scoped=true", function () {
      api.rerender('c5a0890e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bookkeeping/BookkeepingBrowse.vue"
export default component.exports